import { apiUrl } from "helpers/constants/config.constants";
import { httpDelete, httpGet, httpPatch, httpPost } from "./http.service";
import { AxiosResponse } from "axios";
import { FileObject } from "./file.service";

export interface Product {
  productId: string
  name: string
  code: string
  description: string
  material: string
  price: number
  retailPrice: number
  wholeSalePrice: number
  discount: number
  fixedFee: number
  categoryId: string
  images: Array<string>
  specification: Array<Record<string, string>>
  configs: Array<Record<string, unknown>>
  cartConfigs: Array<Record<string, unknown>>
}

export interface ProductCategory {
  productCategoryId: string
  categoryName: string
  image: string
  files: FileObject[]
}

export const listProducts = (skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.product.list, { skip }).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doListOrderProducts = (skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.product.listOrder, { skip }).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doGetProductDetail = (productId: string) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.product.get(productId)).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const createProduct = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    try {
      httpPost(apiUrl.product.create, { ...params }).then((res) => {
        const product = res as unknown as Product;
        const configs = params?.configs as Array<Record<string, unknown>>[];
        if (product && configs && configs.length > 0) {
          httpPost(apiUrl.productConfig.create(product?.productId),
            { configs: params.configs as Record<string, unknown> })
        }
        resolve(res);
      });

    } catch (error) {
      reject(error);
    }
  });
}

export const updateProduct = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    try {
      const response = httpPatch(apiUrl.product.update(params.productId as string), { ...params });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
}

export const deleteProduct = (id: string) => {
  return new Promise((resolve, reject) => {
    try {
      const response = httpDelete(apiUrl.product.delete(id));
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
}

export const doListProductCategories = (skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.productCategory.list, { skip }).then((res) => {
      const response = res as AxiosResponse
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  });
}

export const doCreateProductCategory = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.productCategory.create, { ...params }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error);
    })
  });
}

export const doUpdateProductCategory = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPatch(apiUrl.productCategory.update(params.productCategoryId as string), { ...params }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error);
    })
  });
}

export const doDeleteProductCategory = (id: string) => {
  return new Promise((resolve, reject) => {
    httpDelete(apiUrl.productCategory.delete(id)).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error);
    })
  });
}

export const doGetProductColors = () => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.setting.listColor).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  });
}
